import { render } from "./AddNewCategorieModal.vue?vue&type=template&id=6ae74f7b&ts=true"
import script from "./AddNewCategorieModal.vue?vue&type=script&lang=ts"
export * from "./AddNewCategorieModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__